import React, { useState, type HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import { Share as KSShare, CopyToClipboard } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

interface ShareProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  title?: string;
  pageTitle?: string;
  items?: string[];
}

const Share: React.FC<ShareProps> = ({
  title = 'Deel deze pagina',
  pageTitle = '',
  items = ['facebook', 'whatsapp', 'linkedin', 'copy'],
}) => {
  const { t } = useTranslation();
  const [copyIcon, setCopyIcon] = useState('link-second');
  const [showTooltip, setShowTooltip] = useState(false);

  // The actual copy is handled in CopyToClipboard component from KS.
  // This function with timeout shows feedback to the user in the form of a
  // tooltip and change of the icon to a checkmark.
  const handleCopyClick = () => {
    setShowTooltip(true);
    setCopyIcon('checkmark-no-background');

    setTimeout(() => {
      setShowTooltip(false);
      setCopyIcon('link-second');
    }, 2000);
  };

  return (
    <div>
      <KSShare
        title={title}
        items={items}
        pageTitle={pageTitle}
        customItems={{
          copy: (
            <button className="Share__copy_link" onClick={handleCopyClick} type="button" aria-label={t('social_share.labels.copy')}>
              <CopyToClipboard
                text={window.location.href}
                icon={copyIcon}
                copyText=""
                copiedText=""
              />
              {showTooltip && (
                <div className="tooltip">
                  {t('social_share.labels.copied')}
                </div>
              )}
            </button>
          ),
        }}
      />
    </div>
  );
};

export default Share;
